import { Typography } from '@material-ui/core'

import { addCommaToPrice } from '../../../../helpers/numbers'
import { persianRegex } from '../../../../helpers/regex'
import { getTranslate } from '../../../../localization'
import { CartPaymentInfo } from '../../../../types/cart'
import useStyles from './styles/index.styles'

type Props = {
  channelName: string
  paymentInfo?: CartPaymentInfo
}

const ChannelBalance = ({ channelName, paymentInfo }: Props) => {
  const classes = useStyles()
  const isPersian = persianRegex.test(channelName)
  return (
    <div className={classes.root}>
      <div className={classes.ballancedetails}>
        <Typography variant="h6" className={classes.text}>
          {getTranslate('Channel Name')}
        </Typography>
        <Typography
          variant="h6"
          className={classes.text}
          style={isPersian ? { fontFamily: 'IranSans' } : undefined}>
          {channelName}
        </Typography>
      </div>
      {paymentInfo?.walletType && (
        <div className={classes.ballancedetails}>
          <Typography variant="h6" className={classes.text}>
            {getTranslate('Payment Method')}
          </Typography>
          <Typography variant="h6" className={classes.text}>
            {getTranslate(paymentInfo?.walletType)}
          </Typography>
        </div>
      )}
      {paymentInfo && (
        <div className={classes.ballancedetails}>
          <Typography variant="h6" className={classes.text}>
            {getTranslate('Cash Balance')}
          </Typography>
          <Typography variant="h6" className={classes.text}>
            {`${addCommaToPrice(
              paymentInfo?.cashBalance > 0 ? paymentInfo?.cashBalance : 0
            )} ${getTranslate(paymentInfo?.currency || '')}`}
          </Typography>
        </div>
      )}
      {paymentInfo && (
        <div className={classes.ballancedetails}>
          <Typography variant="h6" className={classes.text}>
            {getTranslate('Remainig Credit')}
          </Typography>
          <Typography variant="h6" className={classes.text}>
            {`${
              paymentInfo?.remainingCreditBalance
                ? `${addCommaToPrice(paymentInfo?.remainingCreditBalance)}`
                : 0
            } ${getTranslate(paymentInfo?.currency || '')}`}
          </Typography>
        </div>
      )}
    </div>
  )
}

export default ChannelBalance
